import React, { forwardRef, useRef, useContext } from "react";
import KeyValueDisplay from "../components/KeyVakueDisplay";
import { dateTimeFormatted } from "../../main";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import { useEventContext } from "../../contexts/EventContextProvider";
import { PlaceholderContext } from "../../contexts/Contexts";
import { ErrorDialog } from "../modal/Dialog";
import ExpandableTokens from "../../widgets/ExpandableTokens";

const TagGroupDisplayBar = forwardRef((p, r) => {

    const { state, eventDispatch } = useEventContext();
    const placeholder = useContext(PlaceholderContext);

    //console.log('DiscountCouponDisplayBar.p', p)

    const render = (p) => {
        return (
            <div className="flex-row" ref={r}>
                <div className="col-24">
                    <div className="ListItemDetails">
                        <div className="flex-column">
                            <div className="flex-row">
                                <input type="hidden" name="id" value={p.id || ''} />
                                <div className="col-6">
                                    <KeyValueDisplay label='name' value={p.name} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='color' value={p.color} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='created on' value={dateTimeFormatted(p.createdAt)} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='updated on' value={dateTimeFormatted(p.updatedAt)} />
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="col-24">
                                    <KeyValueDisplay label='description' value={p.description || 0} />
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="col-24">
                                    <ExpandableTokens list={p.tags} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const renderCase = (state) => {
        //console.log('renderCase', state?.data?.id > 0, state?.visibility, state?.id > 0 && state?.visibility);
        switch (true) {
            case state?.state == 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case state?.data?.id > 0 && state.visibility:
                //console.log('renderCase.done', state);
                return render(state.data);
            case state?.state == 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    return (state?.tagGroups && state.tagGroups[p.id]) ? renderCase(state.tagGroups[p.id]) : <></>;
});

export default TagGroupDisplayBar;